/*
  The addresses that several features link to, in one place so they are written the same way everywhere:
  the upload screen (workflow 02), the add-by-hand form, and the open points.
*/

import type { Id } from "../api/types";

/** The upload screen. With a session it adds the document to that session. */
export function uploadPath(sessionId?: Id | null): string {
  return sessionId ? `/deliverables/new?session=${encodeURIComponent(sessionId)}` : "/deliverables/new";
}

export interface AddByHandSeed {
  /** The kind of element the form opens on; without it the person picks one. */
  kind?: string | null;
  /** The session the element is added for: the agent learns of it and the item is the session's. */
  session?: Id | null;
  /** Where an item or a heading sits: the form opens with these chosen. */
  library?: Id | null;
  family?: Id | null;
  subFamily?: Id | null;
}

/** The add-by-hand form, with the kind, the session and the place in the family tree filled in as far as they are known. */
export function addByHandPath(seed: AddByHandSeed = {}): string {
  const query = new URLSearchParams();
  if (seed.kind) query.set("kind", seed.kind);
  if (seed.session) query.set("session", seed.session);
  if (seed.library) query.set("library", seed.library);
  if (seed.family) query.set("family", seed.family);
  if (seed.subFamily) query.set("sub_family", seed.subFamily);
  const text = query.toString();
  return text ? `/elements/new?${text}` : "/elements/new";
}

export const OPEN_POINTS_PATH = "/open-points";
